import { map } from 'lodash';

export const REWARD_CALC_DATA = (t = key => key) => [
  {
    offerId: 4325,
    description: t('rewardData.aliexpress.description'),
    title: t('rewardData.aliexpress.title'),
    noCommission: t('rewardData.aliexpress.noCommission'),
    warning: t('rewardData.aliexpress.warning'),
    urlError: t('rewardData.aliexpress.urlError'),
    linksLimit: 50
  },
  {
    offerId: 34886,
    description: t('rewardData.aliexpress.description'),
    title: t('rewardData.aliexpress.title'),
    noCommission: t('rewardData.aliexpress.noCommission'),
    warning: t('rewardData.aliexpress.warning'),
    urlError: t('rewardData.aliexpress.urlError'),
    linksLimit: 50
  },
]

export const OFFERS_WITH_REWARD_CALCULATOR = map(REWARD_CALC_DATA(), 'offerId');
